









































































import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import {AddressTitle, Salutation} from "@/helpers/constants";
import {enumToSelectItems} from "@/helpers/functions_asi";
import {AxiosError} from "axios";
import AsiTextField from "@/components/common/AsiTextField";
import AsiCountryAutocompleteInput from "@/components/common/AsiCountryAutocompleteInput.vue";
import AsiCheckbox from "@/components/common/AsiCheckbox";
import CompanySimple from "@/models/company/CompanySimple";
import AsiAutocomplete from "@/components/common/AsiAutocomplete";
import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";
import AddressBilling from "@/models/address/AddressBilling";
import AddressBillingUpdate from "@/models/address/AddressBillingUpdate";
import AsiSwitch from "@/components/common/AsiSwitch";
import AsiBtn from "@/components/common/AsiBtn.vue";
import Address from "@/models/address/Address";

@Component({
	components: {
		AsiBtn,
		AsiSwitch,
		AsiDialogFormLayout,
		AsiAutocomplete,
		AsiCheckbox, AsiCountryAutocompleteInput, AsiTextField
	}
})
export default class CompanyUpdateDialogBillingAddress extends AsiDialogForm {

	@Prop({type: Object, required: true})
	public address!: AddressBilling;

	@Prop({type: Object, required: true})
	public templateAddress!: Address;

	@Prop({type: Object, required: true})
	public company!: CompanySimple | null;

	private model: AddressBillingUpdate | null = null;
	private salutationOptions = enumToSelectItems(Salutation, true);
	private titleOptions = enumToSelectItems(AddressTitle, true);

	public created(): void {
		this.setAddressInternal();
	}

	@Emit('save')
	public save(event: Event): Event {
		return event;
	}

	@Emit('cancel')
	public cancel(event: Event): Event {
		this.setAddressInternal();
		const form = this.$refs.form as HTMLFormElement;
		this.reset([], form);
		return event;
	}

	@Watch('address', {deep: true})
	private onAddressChanged(): void {
		this.setAddressInternal();
	}

	private setAddressInternal(): void {
		if (this.model === null) {
			this.model = new AddressBillingUpdate(this.address);
		} else {

			this.model.setDetailModel(this.address);
		}
	}

	private requestSave(event: Event): void {
		if (this.company === null || this.model === null) return;

		this.loading = true;
		this.$companyService.updateBillingAddress(this.company.id, this.model)
			.then(() => this.save(event))
			.catch((err: AxiosError) => {
				this.errors = err.response?.data;
			})
			.finally(() => {
				this.loading = false;
			});
	}

	private copyFromTemplate(): void {
		if (this.model === null || this.templateAddress === null) return;

		this.model.phone = this.templateAddress.phone;
		this.model.emails = this.templateAddress.emails;

		this.model.salutation = this.templateAddress.salutation;
		this.model.title = this.templateAddress.title;
		this.model.firstname = this.templateAddress.firstname;
		this.model.lastname = this.templateAddress.lastname;
		this.model.company = this.templateAddress.company;
		this.model.address1 = this.templateAddress.address1;
		this.model.address2 = this.templateAddress.address2;
		this.model.street = this.templateAddress.street;
		this.model.city = this.templateAddress.city;
		this.model.zip = this.templateAddress.zip;
		this.model.county = this.templateAddress.county;
		this.model.state = this.templateAddress.state;
		this.model.countryCode = this.templateAddress.countryCode;
	}

}
